import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ForecastDay } from '@library/store/homes/homes.interface';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { DirectivesModule } from '@library/ui/directives/directives.module';
import { WeatherForecastModule } from '@library/ui/molecules/weather-forecast/weather-forecast.module';
import { ForecastIconAssetsPath } from '@library/ui/molecules/weather-forecast/weather-forecast.service';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { WeathermapFacade } from '@store/weathermap.facade';
import * as moment from 'moment-timezone';

const DefaultForecastDays = [
  { day_ts: moment().unix() } as ForecastDay,
  { day_ts: moment().add(1, 'day').unix() } as ForecastDay,
  { day_ts: moment().add(2, 'day').unix() } as ForecastDay,
  { day_ts: moment().add(3, 'day').unix() } as ForecastDay,
  { day_ts: moment().add(4, 'day').unix() } as ForecastDay,
];

@Component({
  selector: 'app-forecast',
  imports: [
    WeatherForecastModule,
    PipesModule,
    DirectivesModule,
    TextModule,
  ],
  providers: [
    { provide: ForecastIconAssetsPath, useValue: '/assets/weather-forecast-icons' },
  ],
  templateUrl: './forecast.component.html',
  styleUrl: './forecast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForecastComponent {
  type = EnumMeasureTypes.TEMPERATURE;

  station = this.weathermapFacade.selectedStation;
  forecastDays = computed(() => this.station().forecast?.forecastDays ?? DefaultForecastDays);

  constructor(
    private readonly weathermapFacade: WeathermapFacade,
  ) {}

  getDay(time: number): string {
    if (time) {
      return moment(time * 1000).format('dddd');
    }
    else {
      return '--';
    }
  }
}
